import * as React from 'react';
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Button,
  List,
  ListItem,
  ListItemText,
} from '@mui/material';

export interface FilaEsperaConfirmModalProps {
  open: boolean;
  categoriasFila: string[];
  onCancel: () => void;
  onConfirm: () => void;
  loading?: boolean;
}

/**
 * Modal exibido antes da confirmação final da inscrição quando ao menos
 * uma categoria selecionada vai entrar em fila de espera (vagas esgotadas
 * + fila efetiva ativa). Permite ao atleta cancelar ou prosseguir
 * conscientemente.
 */
export const FilaEsperaConfirmModal: React.FC<FilaEsperaConfirmModalProps> = ({
  open,
  categoriasFila,
  onCancel,
  onConfirm,
  loading,
}) => {
  return (
    <Dialog open={open} onClose={loading ? undefined : onCancel} maxWidth="sm" fullWidth>
      <DialogTitle>Confirmar inscrição em fila de espera</DialogTitle>
      <DialogContent>
        <DialogContentText>
          {categoriasFila.length === 1
            ? 'A categoria abaixo está com vagas esgotadas; sua inscrição entrará na fila de espera e será efetivada apenas se uma vaga abrir:'
            : 'As categorias abaixo estão com vagas esgotadas; sua inscrição entrará na fila de espera e será efetivada apenas se uma vaga abrir:'}
        </DialogContentText>
        <List dense>
          {categoriasFila.map((nome) => (
            <ListItem key={nome} sx={{ py: 0 }}>
              <ListItemText primary={`• ${nome}`} />
            </ListItem>
          ))}
        </List>
      </DialogContent>
      <DialogActions>
        <Button onClick={onCancel} disabled={loading}>
          Cancelar
        </Button>
        <Button onClick={onConfirm} variant="contained" color="primary" disabled={loading}>
          Confirmar Inscrição
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default FilaEsperaConfirmModal;
